import { GeoShapeToolbarProps } from './Types'
import { track } from '@tldraw/tldraw'
import { Toolbar } from '../ContextToolbar/Toolbar'
import { CopyButton } from '../components/CopyButton/CopyButton'
import { DeleteButton } from '../components/DeleteButton/DeleteButton'
import { MoreOptionsButton } from '../components/MoreOptionsButton/MoreOptionsButton'

const GeoShapeToolbar = track(({ editor, shapeId }: GeoShapeToolbarProps) => {
  const shape = editor.getShape(shapeId)

  return (
    <Toolbar>
      <CopyButton />
      <DeleteButton />
      <MoreOptionsButton selectedShape={shape} />
    </Toolbar>
  )
})

export { GeoShapeToolbar }
